// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5696":"e541a4994da59cde16de","9586":"4f5b596344b20d304ffa"}[chunkId] + ".css";
};